import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    firstName: yup.string().required('First Name is required'),
    lastName: yup.string().required('Last Name is required'),
    phoneNumber: yup
        .string()
        .min(10, 'Phone number should contain 10 characters length')
        .required('Phone number is required'),
});
